export default "__VITE_ASSET__CFnimi7b__"